// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__YpdD6","modalDialog":"styles_modalDialog__4sGnm","iframe":"styles_iframe__yRSWU"};